<script setup lang="ts">
const { vacancy } = defineProps<{ vacancy: Vacancy }>()

const { t } = useI18n({
  useScope: 'local',
})

const hasRequirements
  = vacancy.vogRequired || vacancy.dutchRequired || vacancy.otherRequirement

const iconClass = 'text-primary-500 size-6 mr-1'
</script>

<template>
  <div v-if="hasRequirements" class="flex flex-col gap-2">
    <BaseHeading
      tag="h3"
      size="xl"
      weight="normal"
      class="mb-2"
    >
      {{ t('requirements') }}
    </BaseHeading>

    <div v-if="vacancy.dutchRequired" class="flex items-center gap-4">
      <Icon name="ph:flag-duotone" :class="iconClass" />
      <div>
        <BaseParagraph>
          {{ t('dutchRequired') }}
        </BaseParagraph>
      </div>
    </div>
    <div v-if="vacancy.vogRequired" class="flex items-center gap-4">
      <Icon
        name="fluent:document-bullet-list-clock-20-regular"
        :class="iconClass"
      />
      <div>
        <BaseParagraph>
          {{ t('vogRequired') }}
        </BaseParagraph>
      </div>
    </div>
    <div v-if="vacancy.otherRequirement" class="flex items-center gap-4">
      <Icon name="material-symbols:add-task" :class="iconClass" />
      <div>
        <BaseParagraph>
          {{ vacancy.otherRequirement }}
        </BaseParagraph>
      </div>
    </div>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "requirements": "Requirements",
    "vogRequired": "Statement of conduct required",
    "dutchRequired": "Dutch required"
  },
  "nl": {
    "requirements": "Vereisten",
    "vogRequired": "VOG verplicht",
    "dutchRequired": "Nederlandse taal"
  }
}
</i18n>
